import { CircleX } from 'lucide-react';
import { useRouteError } from 'react-router';
import { urlHome } from '@/urls';
import { StatusPage } from '@/components/common/status-page';
import { IS_DEV } from '@/data/constants';
import { ErrorCode } from '@repo/shared-types';

const actions: Record<ErrorCode, { label: string; url: string }[]> = {
  [ErrorCode.INVALID_EMAIL_OR_PASSWORD]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.INVALID_TYPE]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.TOO_BIG]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.TOO_SMALL]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.INVALID_FORMAT]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.NOT_MULTIPLE_OF]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.UNRECOGNIZED_KEYS]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.INVALID_UNION]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.INVALID_KEY]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.INVALID_ELEMENT]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
  [ErrorCode.INVALID_VALUE]: [
    {
      label: 'Volver a la página principal',
      url: urlHome(),
    },
  ],
};

export function ErrorBoundary() {
  const { message, code } = useRouteError() as { message: string; code: ErrorCode };

  let finalMessage = 'Ocurrió un error, por favor intenta nuevamente.';

  if (IS_DEV) {
    finalMessage = message + ' ' + code;
  }

  return (
    <StatusPage
      title="Error"
      description={finalMessage}
      actions={actions[code]}
      icon={CircleX}
      color="red"
    />
  );
}
